// Of two copies of a workflow's stored test (draft meta.test), the later one by revision, which every save bumps on
// the server; a test saved before revisions existed is revision 0. Never by the browser's clock.
const newerWorkflowTest = (held, incoming) => {
  if (!incoming) {
    return held ?? null;
  }

  return held && (held.revision ?? 0) > (incoming.revision ?? 0) ? held : incoming;
};

export default newerWorkflowTest;
